export default __webpack_public_path__ + "static/media/user_line.b14b935d.svg";